<template>
  <div>
    <list row-key="id" ref="list" unit="订单" :page="page" :query-params="params" :show-checkbox="showCheckbox"
      :show-query="showQuery" :get-data-func="getDataFunc" :after-get-data-func="setStyle" :toolbar-left="16"
      :toolbar-right="8" custom-class="merge-table">
      <div slot="toolbar">
        <div class="toolbar">
          <el-select v-model="quickCheck" @change="onQuickCheck" style="width: 100px;" clearable>
            <el-option label="快捷勾选" :value="0"></el-option>
            <el-option label="全部勾选" :value="1"></el-option>
            <el-option label="取消勾选" :value="2"></el-option>
          </el-select>
          <el-select v-model="temp" style="width: 300px;margin: 0 10px;">
            <el-option v-for="(i, k) in ExpressList" :key="k" :label="i.name + '，剩余单数' + i.number"
              :value="i.id"></el-option>
          </el-select>
          <el-button type="primary" @click="openPrint()">打印快递单</el-button>
          <el-button type="primary" @click="openPrintWithSend()">一键发货</el-button>
          <el-dropdown @command="moreAction" style="margin: 0 10px;">
            <el-button type="primary">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batchEditRemark">批量修改备注</el-dropdown-item>
              <el-dropdown-item command="batchRecycleNumber">批量回收单号</el-dropdown-item>
              <el-dropdown-item command="batchLock">批量锁定</el-dropdown-item>
              <el-dropdown-item command="batchUnlock">批量解锁</el-dropdown-item>
              <el-dropdown-item command="batchConsolidateOrders">批量合并订单</el-dropdown-item>
              <el-dropdown-item command="exportBackOrders">导出回传 Excel</el-dropdown-item>
              <el-dropdown-item command="backOrders">回传 Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="openSetting">设置</el-button>
          <div class="fullscreen-btn">
            <svg-icon v-if="fullscreen" iconClass="cancelfullscreen" @click="setScreen" />
            <svg-icon v-else iconClass="fullscreen" @click="setScreen" />
          </div>
        </div>
        <div class="toolbar">
          <div class="toolbar-left">
            <span>共查到</span>
            <span class="number">{{ totalOrder }}</span>
            <span>个订单，共</span>
            <span class="number">{{ totalParcel }}</span>
            <span>个包裹</span>
          </div>
          <div class="toolbar-right">
            <div style="display: flex;align-items: center;margin-right: 10px;">
              <div style="font-size: 14px;color: #606266;">订单排序：</div>
              <el-select v-model="snField" style="width: 150px">
                <el-option label="商品名称" value="goodsName"></el-option>
                <el-option label="规格名称" value="goodsSpec"></el-option>
                <el-option label="发货时间" value="lastShipTime"></el-option>
                <el-option label="省份城市" value="province"></el-option>
                <el-option label="付款时间" value="payTime"></el-option>
                <el-option label="商品数量" value="goodsCount"></el-option>
                <el-option label="商品金额" value="goodsPrice"></el-option>
                <el-option label="实付金额" value="payAmount"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="onSnUp">升序</el-button>
            <el-button type="primary" @click="onSnDown">降序</el-button>
          </div>
        </div>
      </div>
      <template slot="query">
        <!-- <el-form-item label="店铺名称" label-width="112px">
          <el-select v-model="mallToken" placeholder="请选择">
            <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.token"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="商品搜索" label-width="112px">
          <el-input v-model="params.goodsFilter" placeholder="请输入商品名称/ID" clearable />
        </el-form-item>
        <el-form-item label="规格搜索" label-width="112px">
          <el-input v-model="params.specFilter" placeholder="请输入规格名称/ID" clearable />
        </el-form-item>
        <el-form-item label="交易状态" label-width="112px">
          <el-select v-model="params.orderStatusDesc" placeholder="请选择" clearable>
            <!-- <el-option label="等待买家付款" value="等待买家付款"></el-option> -->
            <!-- <el-option label="等待卖家发货" value="等待卖家发货"></el-option> -->
            <el-option label="等待物流公司揽件" value="等待物流公司揽件"></el-option>
            <el-option label="等待买家收货" value="等待买家收货"></el-option>
            <el-option label="等待买家签收" value="等待买家签收"></el-option>
            <el-option label="买家已签收" value="买家已签收"></el-option>
            <el-option label="已收货" value="已收货"></el-option>
            <el-option label="交易成功" value="交易成功"></el-option>
            <el-option label="交易取消" value="交易取消"></el-option>
            <el-option label="交易终止" value="交易终止"></el-option>
            <el-option label="已收货待到账" value="已收货待到账"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后状态" label-width="112px">
          <el-select v-model="params.isRefund" placeholder="请选择" clearable>
            <el-option label="无售后" :value="false"></el-option>
            <el-option label="有售后" :value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注留言" label-width="112px">
          <el-select v-model="params.buyerMemo" placeholder="请选择" clearable>
            <el-option label="无商家备注" :value="0"></el-option>
            <el-option label="有商家备注" :value="1"></el-option>
            <el-option label="有买家备注" :value="2"></el-option>
            <el-option label="无买家备注" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <el-select v-model="params.fieldType" style="width: 100px;">
              <el-option label="智能搜索" value="sbSearch"></el-option>
              <el-option label="商品件数" value="goodsCount"></el-option>
              <el-option label="订单号" value="orderSn"></el-option>
              <el-option label="快递单号" value="expressNumber"></el-option>
              <el-option label="商品价格" value="goodsPrice"></el-option>
              <el-option label="实付金额" value="payAmount"></el-option>
              <el-option label="收件人" value="receiverName"></el-option>
              <el-option label="手机号" value="receiverPhone"></el-option>
            </el-select>
          </div>
          <el-input v-model="params.fieldValue" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="退款状态" label-width="112px">
          <el-select v-model="params.hasRefund" placeholder="请选择" clearable>
            <el-option label="有退款" :value="1"></el-option>
            <el-option label="无退款" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区选择" label-width="112px">
          <address-select v-model="params.area" :placeholder="'请选择地区'" @change="onAddressSelect" />
        </el-form-item>
        <el-form-item label="旗帜选择" label-width="112px">
          <el-select v-model="params.flag" placeholder="请选择" clearable>
            <el-option label="红" value="flag-red">红<i class="el-icon-s-flag flag-red"></i></el-option>
            <el-option label="橙" value="flag-orange">橙<i class="el-icon-s-flag flag-orange"></i></el-option>
            <el-option label="黄" value="flag-yellow">黄<i class="el-icon-s-flag flag-yellow"></i></el-option>
            <el-option label="绿" value="flag-green">绿<i class="el-icon-s-flag flag-green"></i></el-option>
            <el-option label="蓝" value="flag-blue">蓝<i class="el-icon-s-flag flag-blue"></i></el-option>
            <el-option label="靛" value="flag-indigo">靛<i class="el-icon-s-flag flag-indigo"></i></el-option>
            <el-option label="紫" value="flag-purple">紫<i class="el-icon-s-flag flag-purple"></i></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递公司" label-width="112px">
          <el-select v-model="params.expressName" placeholder="请选择" clearable>
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.logisticsCompany" :value="i.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间类型" label-width="112px">
          <div class="time-type">
            <el-select v-model="params.timeType">
              <!-- <el-option label="成团时间" value="成团时间"></el-option> -->
              <el-option label="下单时间" value="createTime"></el-option>
              <el-option label="发货时间" value="lastShipTime"></el-option>
              <!-- <el-option label="剩余时间" value="shippingTime"></el-option> -->
            </el-select>
            <range-picker :date="[params.startDate, params.endDate]"
              @change="x => { params.startDate = x.Start; params.endDate = x.End; }" />
          </div>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column label="收件信息" min-width="280px">
          <div slot-scope="{row}" class="merge-item">
            <div>
              <template v-if="row.multiorder.length > 1">
                <div class="badge badge-merge">合单{{ row.multiorder.length }}</div>
              </template>
<template v-if="row.state != 0 && row.logistics.length > 0">
                <template v-if="row.logistics.length > 1 || row.logistics[0].noList.length > 1">
                  <div class="badge badge-multiple-pack">多包</div>
                </template>
</template>
<span>{{ row.receiverAddress.fullName }}
  <template v-if="dataMasking && row.receiverAddress.fullName != row.decryptData.fullName">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'fullName')" />
                </template>
</span>
<span>，<span v-html="row.receiverAddress.mobilePhone"></span>
  <template v-if="dataMasking && row.receiverAddress.mobilePhone != row.decryptData.mobilePhone">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'mobilePhone')" />
                </template>
</span>
</div>
<div>
  <span>{{ row.address }}</span>
  <span>{{ row.receiverAddress.detailAddress }}
    <template v-if="dataMasking && row.receiverAddress.detailAddress != row.decryptData.detailAddress">
                  <svg-icon class="lock-btn" iconClass="lock" @click="setUnlock(row, 'detailAddress')" />
                </template>
  </span>
</div>
</div>
</el-table-column>
<el-table-column label="合计" min-width="130px">
  <div slot-scope="{row}" class="merge-item">
    <div>
      <span>总数量：</span>
      <span>{{ row.items.map(x => x.goodsCount).reduce((a, b) => { return a + b }) }}</span>
    </div>
    <div>
      <span>总价：</span>
      <span>{{ row.goodsPrice }}</span>
    </div>
    <div>
      <span>实收：</span>
      <span>{{ row.payAmount }}</span>
    </div>
  </div>
</el-table-column> -->
        <!-- <el-table-column label="商品信息" min-width="500px">
          <template slot-scope="{row}">
            <div v-for="(order, key) in row.multiorder" :key="key" :id="'order_' + order.id" class="merge-item"
              style="padding: 0;">
              <div v-for="(i, k) in order.items" :key="k" class="merge-item goods-info"
                :class="{ 'merge': order.items.length > 1 }">
                <div class="item-image">
                  <el-image v-if="i.goodsImageUrl" :src="i.goodsImageUrl" fit="contain">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div class="item-info">
                  <div class="ellipsis" :title="i.goodsName">{{ i.goodsName }}</div>
                  <div style="color: #9d9d9d"><span>规格：</span><span>{{ i.goodsSpec }}</span></div>
                  <div style="color: #9d9d9d"><span>数量：</span><span>{{ i.goodsCount }}</span></div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单时间" min-width="240px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'time_' + order.id">
              <div><span>成团时间：</span><span>{{ order.Field4_2 }}</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" width="70px" align="center">
          <div slot-scope="{row}" class="merge-item">
            <span v-if="row.state == 0">未打印</span>
            <span v-if="row.state == 1">已打印</span>
            <span v-if="row.state == 2">已锁定</span>
            <span v-if="row.state == 3">已发货</span>
          </div>
        </el-table-column>
        <el-table-column label="备注/旗帜" min-width="280px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'remark_' + order.id">
              <div v-if="order.Field6_1 == 0"><i class="el-icon-s-flag flag-red"></i></div>
              <div v-if="order.Field6_1 == 1"><i class="el-icon-s-flag flag-orange"></i></div>
              <div v-if="order.Field6_1 == 2"><i class="el-icon-s-flag flag-yellow"></i></div>
              <div v-if="order.Field6_1 == 3"><i class="el-icon-s-flag flag-green"></i></div>
              <div v-if="order.Field6_1 == 4"><i class="el-icon-s-flag flag-blue"></i></div>
              <div v-if="order.Field6_1 == 5"><i class="el-icon-s-flag flag-indigo"></i></div>
              <div v-if="order.Field6_1 == 6"><i class="el-icon-s-flag flag-purple"></i></div>
              <div><span>买家备注：</span><span>{{ order.Field6_2 || "无" }}</span></div>
              <div><span>卖家备注：</span><span>{{ order.Field6_3 || "无" }}</span></div>
              <div><el-button type="text" @click="editRemark(order)">修改</el-button></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单编号/店铺名称" min-width="200px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'mall_' + order.id">
              <div>{{ order.orderNumber }}</div>
              <div>{{ order.mall.mallName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="快递信息" min-width="200px">
          <div slot-scope="{row}" class="merge-item">
            <template v-if="row.logistics && row.logistics.length > 0">
              <div v-for="(i1, k1) in row.logistics" :key="k1">
                <div>{{ i1.name }}：</div>
                <div v-for="(i2, k2) in i1.noList" :key="k2">{{ i2 }}</div>
              </div>
              <div><el-button type="text" @click="onCopy(row)">复制</el-button></div>
            </template>
            <span v-else>- -</span>
          </div>
        </el-table-column>
        <el-table-column label="单号状态" min-width="100px">
          <div slot-scope="{row}" class="merge-item">
            <div>
              <span v-if="row.Field9 == 0">- -</span>
              <span v-if="row.Field9 == 1">取号失败</span>
              <span v-if="row.Field9 == 2">正常</span>
              <span v-if="row.Field9 == 3">已回收</span>
              <span v-if="row.Field9 == 4">部分回收</span>
            </div>
            <div><el-button type="text" @click="showRecycle(row)">查看详情</el-button></div>
          </div>
        </el-table-column> -->
        <el-table-column prop="aliMallMallName" label="店铺名称" min-width="150px">
          <div slot-scope="{row}" class="merge-item">{{ row.aliMallMallName }}</div>
        </el-table-column>
        <el-table-column label="地址" min-width="300px">
          <div slot-scope="{row}" class="merge-item">
            <span>{{ row.province || '' }}{{ row.city || '' }}{{ row.district || '' }}{{ row.town || '' }}</span>
            <span>{{ row.address || '' }}</span>
          </div>
        </el-table-column>
        <el-table-column prop="receiverName" label="收货人" min-width="80px">
          <div slot-scope="{row}" class="merge-item">{{ row.receiverName }}</div>
        </el-table-column>
        <el-table-column prop="receiverPhone" label="收货电话" min-width="110px">
          <div slot-scope="{row}" class="merge-item">{{ row.receiverPhone }}</div>
        </el-table-column>
        <el-table-column prop="buyer" label="下单人名称" min-width="100px">
          <div slot-scope="{row}" class="merge-item">{{ row.buyer }}</div>
        </el-table-column>
        <el-table-column label="备注/旗帜" min-width="400px">
          <template slot-scope="{row}">
            <div class="merge-item info-center" v-for="(order, key) in row.multiorder" :key="key"
              :id="'remark_' + order.id">
              <div v-if="order.flag"><i class="el-icon-s-flag" :class="order.flag"></i></div>
              <div><span>买家备注：</span><span>{{ order.buyerMemo || "无" }}</span></div>
              <div><span>卖家备注：</span><span>{{ order.remark || "无" }}</span></div>
              <div><el-button type="text" @click="editRemark(order)">修改</el-button></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="discountAmount" label="折扣金额" min-width="100px">
          <div slot-scope="{row}" class="merge-item">{{ row.discountAmount }}</div>
        </el-table-column>
        <el-table-column prop="expressName" label="物流公司名称" min-width="180px">
          <div slot-scope="{row}" class="merge-item">{{ row.expressName }}</div>
        </el-table-column>
        <el-table-column prop="logisticsId" label="物流ID" min-width="150px">
          <div slot-scope="{row}" class="merge-item">{{ row.logisticsId }}</div>
        </el-table-column>
        <el-table-column prop="expressNumber" label="物流单号" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.expressNumber }}</div>
        </el-table-column>
        <el-table-column prop="lastShipTime" label="发货时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.lastShipTime }}</div>
        </el-table-column>
        <el-table-column prop="logisticsStatus" label="物流状态" min-width="160px">
          <div slot-scope="{row}" class="merge-item">
            <!-- WAITACCEPT:未受理;CANCEL:已撤销;ACCEPT:已受理;TRANSPORT:运输中;NOGET:揽件失败;SIGN:已签收;UNSIGN:签收异常 -->
            <span v-if="row.logisticsStatus == 'WAITACCEPT'">未受理</span>
            <span v-if="row.logisticsStatus == 'CANCEL'">已撤销</span>
            <span v-if="row.logisticsStatus == 'ACCEPT'">已受理</span>
            <span v-if="row.logisticsStatus == 'TRANSPORT'">运输中</span>
            <span v-if="row.logisticsStatus == 'NOGET'">揽件失败</span>
            <span v-if="row.logisticsStatus == 'SIGN'">已签收</span>
            <span v-if="row.logisticsStatus == 'UNSIGN'">签收异常</span>
          </div>
        </el-table-column>
        <el-table-column prop="goodsCount" label="商品数量" min-width="80px">
          <div slot-scope="{row}" class="merge-item">{{ row.goodsCount }}</div>
        </el-table-column>
        <el-table-column prop="goodsId" label="商品ID" min-width="130px">
          <div slot-scope="{row}" class="merge-item">{{ row.goodsId }}</div>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="260px">
          <div slot-scope="{row}" class="merge-item">{{ row.goodsName }}</div>
        </el-table-column>
        <el-table-column prop="categoryName" label="类目名称" min-width="130px">
          <div slot-scope="{row}" class="merge-item">{{ row.categoryName }}</div>
        </el-table-column>
        <el-table-column prop="goodsImageUrl" label="商品图片" min-width="110px" align="center">
          <div slot-scope="{row}" class="merge-item">
            <el-image style="width: 80px;height: 80px;" :src="row.goodsImageUrl"></el-image>
          </div>
        </el-table-column>
        <el-table-column prop="orderSn" label="订单编号" min-width="180px">
          <div slot-scope="{row}" class="merge-item">{{ row.orderSn }}</div>
        </el-table-column>
        <el-table-column prop="orderStatusDesc" label="交易状态" min-width="160px">
          <div slot-scope="{row}" class="merge-item">
            <div>{{ row.orderStatusDesc }}</div>
            <div style="color: coral;" v-if="row.postponeDay">
              <div>延长{{ row.postponeDay }}天</div>
              <div>延迟收货时间至</div>
              <div>{{ row.postponeTime }}</div>
            </div>
          </div>
        </el-table-column>
        <el-table-column prop="orderTime" label="订单时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.orderTime }}</div>
        </el-table-column>
        <el-table-column prop="payAmount" label="付款金额" min-width="100px">
          <div slot-scope="{row}" class="merge-item">{{ row.payAmount }}</div>
        </el-table-column>
        <el-table-column prop="payTime" label="支付时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.payTime }}</div>
        </el-table-column>
        <el-table-column prop="shippingAmount" label="运费" min-width="80px">
          <div slot-scope="{row}" class="merge-item">{{ row.shippingAmount }}</div>
        </el-table-column>
        <el-table-column prop="skuId" label="SkuID" min-width="140px">
          <div slot-scope="{row}" class="merge-item">{{ row.skuId }}</div>
        </el-table-column>
        <el-table-column prop="uid" label="下单用户ID" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.uid }}</div>
        </el-table-column>
        <el-table-column prop="afterSalesCreateTime" label="售后创建时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.afterSalesCreateTime }}</div>
        </el-table-column>
        <el-table-column prop="afterSalesStatus" label="售后状态" min-width="100px">
          <div slot-scope="{row}" class="merge-item">{{ row.afterSalesStatus }}</div>
        </el-table-column>
        <el-table-column prop="afterSaleReason" label="售后原因" min-width="300px" show-overflow-tooltip>
          <div slot-scope="{row}" class="merge-item">{{ row.afterSaleReason }}</div>
        </el-table-column>
        <el-table-column prop="refundFree" label="退款金额" min-width="80px">
          <div slot-scope="{row}" class="merge-item">{{ row.refundFree }}</div>
        </el-table-column>
        <el-table-column prop="refundFinishTime" label="售后结束时间" min-width="160px">
          <div slot-scope="{row}" class="merge-item">{{ row.refundFinishTime }}</div>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <print-dialog ref="printDialog" @reload="reload" />
    <express-dialog ref="expressDialog" @close-saved="reload" />
    <remark-dialog ref="remarkDialog" @close-saved="reload" />
    <setting-dialog ref="settingDialog" @close-saved="reload" />
    <recycle-msg-dialog ref="recycleMsgDialog" @closed="reload" />
    <recycle-dialog ref="recycleDialog" />
    <import-dialog ref="importDialog" @upload-success="reload" />
    <submit-rate-dialog ref="submitRateDialog" @closed="reload" />
    <postpone-dialog ref="postponeDialog" @closed="reload" />
  </div>
</template>
<script>
import listMixin from "../mixins/list"; //部分相同的逻辑使用代码混入
import printDialog from "./printDialog";
import expressDialog from "./expressDialog";
import importDialog from "./importDialog"
import submitRateDialog from "./submitRateDialog";
import postponeDialog from "./postponeDialog";
import "../styles/list.scss";

export default {
  mixins: [listMixin],
  components: {
    printDialog, expressDialog, importDialog,
    submitRateDialog, postponeDialog
  },
  data() {
    return {
      totalOrder: 0,
      totalParcel: 0,
    };
  },
  mounted() { },
  methods: {
    getDataFunc(params) {
      params = this.$commonJs.obj.removeNullKey({
        ...params,
        IsShipped: true,
        SnField: this.snField,
        SnType: this.snType,
        [this.params.fieldType]: this.params.fieldValue
      })
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].order.getOrders(params, this.mallToken).then(res => {
          console.log("getDataFunc", params)
          this.totalOrder = res.count;
          this.totalParcel = res.count;

          // res.data = res.data.filter(x => x.receiverAddress.fullName != "");

          res.data = res.data.map(x => {

            var is_same = false;
            // var is_same = res.data.some(w => w.id != x.id && (
            //   w.receiverAddress.fullName == x.receiverAddress.fullName &&
            //   w.receiverAddress.mobilePhone == x.receiverAddress.mobilePhone &&
            //   w.receiverAddress.province == x.receiverAddress.province &&
            //   w.receiverAddress.city == x.receiverAddress.city &&
            //   w.receiverAddress.district == x.receiverAddress.district
            // ))

            var state = 0;
            var logistics = [];
            var multiorder = [{ ...x }];

            // if (x.id == 2) state = 1;
            // if (x.id == 3) {
            //   state = 2;
            //   // 单快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100"] },
            //   ];
            // }
            // if (x.id == 4) {
            //   state = 3;
            //   // 一个单，多商品
            //   multiorder = [{ ...x, items: [...x.items, ...x.items] }];
            // }
            // if (x.id == 5) {
            //   // 合单
            //   multiorder = [{ ...x }, { ...x, id: 12 }];
            // }
            // if (x.id == 6) {
            //   // 多快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100", "YT8962139805100"] },
            //     { name: "中通快递", noList: ["ZT8962139805105", "ZT8962139805105", "ZT8962139805105", "ZT8962139805105"] }
            //   ];
            //   // 合单，单商品与多商品
            //   multiorder = [
            //     { ...x, items: [...x.items, ...x.items] },
            //     { ...x, id: 22 },
            //     { ...x, id: 32, items: [...x.items, ...x.items, ...x.items] }
            //   ];
            // }
            // if (x.id == 7) {
            //   state = 2;
            //   // 单快递，单面单
            //   logistics = [
            //     { name: "中通快递", noList: ["ZT8962139805105"] }
            //   ];
            // }
            // if (x.id == 8) {
            //   state = 2;
            //   // 多快递，多面单
            //   logistics = [
            //     { name: "圆通快递", noList: ["YT8962139805105", "YT8962139805100"] },
            //     { name: "中通快递", noList: ["ZT8962139805105"] }
            //   ];
            // }
            var postponeTime = null;
            if (x.postponeDay) {
              var last = new Date(x.lastShipTime);
              postponeTime = this.$commonJs.toShortDatetimeString(last.setDate(last.getDate() + 10 + Number(x.postponeDay)));
            }
            return {
              ...x,
              state: state,
              multiorder: multiorder, // 合单
              logistics: logistics, // 快递信息
              same: is_same,
              postponeTime,
              decryptData: {
                fullName: "",
                mobilePhone: "",
                address: "",
              }
            }
          })
          resolve(res)
        }).catch(err => {
          resolve({ Code: 1, data: [] })
        })
      })
    },
    submitRate(row) {
      this.$refs.submitRateDialog.openEdit(row);
    },
    postpone(row) {
      console.log("延迟", JSON.parse(JSON.stringify(row)));
      var last = row.lastShipTime;
      var now = new Date();
      var days = this.$commonJs.getIntervalDays(now, last);
      console.log("days", days);
      if (days < 7) {
        this.$message.warning("距离结束时间3天才可申请");
        return;
      }
      this.$refs.postponeDialog.openEdit(row);
    },
    openPrint(data = null) {
      console.log("open", data)
      let rows = [];
      if (data) {
        rows = [data];
      } else {
        rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择数据");
          return;
        }
      }
      if (rows[0].isLock) {
        this.$message.warning("已锁定订单，无法进行操作");
        return;
      }
      this.$refs.printDialog.open().then(that => {
        that.setData({ isPrint: rows[0].isPrint, autoSend: false, rows: rows });
      });
    },
    openPrintWithSend(data = null) {
      this.$message.warning("已发货，无法操作");
    },
    onUpdateExpress(row) {
      console.log("onUpdateExpress", row);
      this.$refs.expressDialog.openEdit(row)
    },
    // 订单导出
    exportExcel() {

    },
    // 导出回传
    exportBackOrders() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this[this.sysType + "Api"].order.getOrders(params).then(res => {
        if (res && res.data) {
          var list = res.data.map(x => {
            return {
              orderSn: x.orderSn,
              expressNumber: "",
            }
          });
          if (list.length > 0) {
            var item = list[0];
            var keys = Object.keys(item);

            import('@/vendor/Export2Excel').then(excel => {
              const tHeader = ['订单编号', '物流单号'];
              const filterVal = keys;
              excel.export_json_to_excel({
                header: tHeader,
                data: this.formatJson(filterVal, list),
                filename: "导出回传_" + this.$commonJs.toDateStringByFormat(new Date, "YYYYMMDDHHmmss"),
              })
              loading.close();
            })
          } else {
            this.$message.error("没有数据可以导出")
            loading.close();
          }
        } else {
          this.$message.error("获取数据失败")
          loading.close();
        }
      })
    },
    backOrders() {
      this.$refs.importDialog.open();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
  },
};
</script>
<style lang="scss"></style>